import { DecimalPipe } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { FeatureManagementService } from '@shared/services/feature-management/feature-management.service';

@Component({
  selector: 'app-course-price-discount',
  templateUrl: './course-price-discount.component.html',
  styleUrls: ['./course-price-discount.component.scss'],
  providers: [DecimalPipe],
})
export class CoursePriceDiscountComponent implements OnChanges {
  @Input() public currency: string;
  @Input() public originalPrice: number;
  @Input() public userPrice: number;
  @Input() public isCard: boolean;

  public savedAmount: string | number;
  public isSavedAmount: boolean = false;
  constructor(
    private decimalPipe: DecimalPipe,
    private featureManagementService: FeatureManagementService
  ) { }

  public ngOnChanges(): void {
    if (this.originalPrice === this.userPrice) {
      this.isSavedAmount = false;
    } else if ((this.originalPrice - this.userPrice) > 0) {
      this.isSavedAmount = true;
    }

    if (this.originalPrice > this.userPrice) {
      if ((this.originalPrice - this.userPrice) > 0) {
        this.savedAmount = (this.originalPrice - this.userPrice);
      }
    }
  }

  public getPriceSubtext(): string {
    if (this.featureManagementService.getFeatureValue("college")) {
      return "Included*";
    }

    return `(Save ${this.decimalPipe.transform(this.savedAmount, "1.0-2")} ${this.currency})`;
  }

  public getTooltipText(): string {
    if (this.featureManagementService.getFeatureValue("college")) {
      return "Included in your college subscription";
    }

    return "";
  }
}
